import cn from 'classnames';
import './styles.scss';

const StickyPageHeader = ({ children, className = ''}) => {
  return <div className={cn('cmp-sticky-page-header', className)}>{children}</div>;
};

export default StickyPageHeader;
